import React from 'react';
import { List } from 'immutable';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import QueueDraggable from 'flow/components/dashboard/creation/hunt-groups/QueueDraggable';
import useAppContext from 'flow/hooks/useAppContext';
import { QueueKey } from 'flow/types/EntityKeys';

interface Props {
    queues: List<QueueKey>;
    onUpdate: (keys: List<QueueKey>) => void;
}

const QueuesSortableDeletable = ({ queues = List(), onUpdate }: Props) => {
    const { i18next } = useAppContext();

    const onSortEnd = ({
        oldIndex,
        newIndex,
    }: {
        oldIndex: number;
        newIndex: number;
    }) => {
        const itemToMove = queues.get(oldIndex);
        const agentsUpdated = queues
            .delete(oldIndex)
            .insert(newIndex, itemToMove);
        onUpdate(agentsUpdated);
    };

    const onClickDelete = (key: QueueKey) => {
        const indexToDelete = queues.findIndex((agentKey) => agentKey === key);
        onUpdate(queues.delete(indexToDelete));
    };

    const SortableItem = SortableElement(({ value }: { value: any }) => {
        return (
            <div className="z-10">
                <QueueDraggable
                    queueKey={value}
                    onClickDelete={onClickDelete}
                />
            </div>
        );
    });

    const SortableList = SortableContainer(
        ({ items }: { items: any /*List<ExtensionKey>*/ }) => {
            return (
                <div className="flex flex-col gap-y-3">
                    {items.map((value: any, index: number) => (
                        <SortableItem
                            key={`item-${index}`}
                            index={index}
                            value={value}
                        />
                    ))}
                </div>
            );
        },
    );

    return (
        <>
            {queues.size ? (
                <SortableList
                    items={queues}
                    onSortEnd={onSortEnd}
                    useDragHandle={true}
                />
            ) : (
                <div className="box-border w-full text-xs text-gray-500">
                    {i18next.t('dashboard.queuing_systems.not_added')}
                </div>
            )}
        </>
    );
};

export default React.memo(QueuesSortableDeletable);
